import React from "react";
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import axios from "axios";
import API from "../helpers/api";
import swal from "sweetalert";
let currentUser = JSON.parse(localStorage.getItem("currentUser"));
class EditSuperintendent extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            techSuperintendentInfo: {
                clientUserId: 0,
                clientId: 0,
                userRole: "superintendent",
                userName: "",
                email: "",
                telephone: '',
                modifiedBy: "",
                isDeleted: false,
            },
            index: 0,
            techSuperintendentArray: []
        }
        this.handleInputChange = this.handleInputChange.bind(this);
        this.updateTechSuperintendent = this.updateTechSuperintendent.bind(this);
        this.addTechSuperintendent = this.addTechSuperintendent.bind(this);
    }

    static getDerivedStateFromProps(nextProps, prevState) {
        const { techSuperintendentList, techSuperintendentDetail, dispatch } = nextProps;
        if (techSuperintendentDetail) {
            prevState.techSuperintendentInfo.clientUserId = techSuperintendentDetail.clientUserId;
            prevState.techSuperintendentInfo.clientId = techSuperintendentDetail.clientId;
            prevState.techSuperintendentInfo.userName = techSuperintendentDetail.userName;
            prevState.techSuperintendentInfo.email = techSuperintendentDetail.email;
            prevState.techSuperintendentInfo.telephone = techSuperintendentDetail.telephone;
            prevState.index = techSuperintendentList.findIndex(x => x.email === techSuperintendentDetail.email);
            dispatch({ type: "GetTechSuperintendentDetails", data: null });
        }
        if (techSuperintendentList) {
            prevState.techSuperintendentArray = techSuperintendentList;
        }
    }

    // handleInputChange(e) {
    //     let nodeName = e.target.name;
    //     this.state.techSuperintendentInfo[nodeName] = e.target.value;
    //     this.setState({});
    // }
    handleInputChange(e) {
        let nodeName = e.target.name;
        const regex = /^\d*$/;
        if (nodeName == 'telephone') {
            if (regex.test(e.target.value)) {
                this.state.techSuperintendentInfo[nodeName] = e.target.value;
            }
        }
        else {
            this.state.techSuperintendentInfo[nodeName] = e.target.value;
        }

        this.setState({});
    }

    addTechSuperintendent() {
        const {
            dispatch,
            match,
            fleetManagerList,
            techSuperintendentList,
            techExecutiveList,
        } = this.props;
        const { params } = match;
        const { id } = params;
        let userArray = [];
        let superintendent = {
            clientId: parseInt(id),
            userRole: "superintendent",
            userName: this.state.techSuperintendentInfo.userName,
            email: this.state.techSuperintendentInfo.email,
            telephone: this.state.techSuperintendentInfo.telephone,
            createdBy: ""
        }
        userArray.push(superintendent);
        let emailregex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
        if (this.state.techSuperintendentInfo.email !== "") {
            if (emailregex.test(this.state.techSuperintendentInfo.email)) {
                const enteredEmail = this.state.techSuperintendentInfo.email.trim();
                const normalizedEmail = enteredEmail.toLowerCase();
                const emailExistsInClient =
                    (fleetManagerList || []).some(
                        (x) => x?.email?.trim().toLowerCase() === normalizedEmail
                    ) ||
                    (techSuperintendentList || []).some(
                        (x) => x?.email?.trim().toLowerCase() === normalizedEmail
                    ) ||
                    (techExecutiveList || []).some(
                        (x) => x?.email?.trim().toLowerCase() === normalizedEmail
                    );

                if (emailExistsInClient) {
                    swal(
                        "Error!",
                        `User with email ${enteredEmail} already exists in this client.`,
                        "warning"
                    );
                    return;
                }

                let url2 = `${API.userExist}?Mail=${this.state.techSuperintendentInfo.email}`
                axios.get(url2, {
                    headers: {
                        key: currentUser.accessToken
                    }
                })
                    .then((response) => {
                        if (response.data === true) {
                            let url = `${API.postClientuser}`;
                            axios.post(url, userArray, {
                                headers: {
                                    key: currentUser.accessToken
                                }
                            })
                                .then((response) => {
                                    let url = `${API.getClientUsers}?clientId=${id}`;
                                    axios.get(url)
                                        .then((response) => {
                                            let fleetManager = response.data && response.data.filter(r => r.userRole === "fleetmanager");
                                            let techSuperintendent = response.data && response.data.filter(r => r.userRole === "superintendent");
                                            let techExecutive = response.data && response.data.filter(r => r.userRole === "technicalexecutive");
                                            dispatch({ type: "GetFleetManagerlist", data: fleetManager });
                                            dispatch({ type: "GetTechSuperintendentlist", data: techSuperintendent });
                                            dispatch({ type: "GetTechExecutivelist", data: techExecutive });
                                            dispatch({
                                                type: "getClientUsersListSuccess",
                                                data: response.data,
                                            })
                                        })
                                        .catch((error) => {
                                            dispatch({
                                                type: "getClientUsersDetailsFailure",
                                                error: "ERROR"
                                            })
                                        })
                                    this.hideSidePanel();
                                    dispatch({
                                        type: "postClientUserDetailSuccess",
                                        data: response.data,
                                    })
                                })
                                .catch((error) => {
                                    dispatch({
                                        type: "postClientUserDetailFailure",
                                        error: "ERROR"
                                    })
                                })
                        } else if (response.data === false) {
                            swal('Error!', 'User already exists.', 'warning');
                            this.state.techSuperintendentInfo.email = "";
                            this.setState({});
                        }
                        dispatch({
                            type: 'getUserExistListSuccess',
                            data: response.data
                        })
                    })
                    .catch((error) => {
                        dispatch({
                            type: 'getUserExistListFailure',
                            data: "error"
                        })
                    })
            }
            else {
                swal('Error!', 'Invalid email format', 'warning');
            }
        } else {
            swal('Error!', 'Email is mandatory', 'warning');
        }
    }

    updateTechSuperintendent() {
        let emailregex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
        const { techSuperintendentInfo } = this.state;
        const { fleetManagerList, techSuperintendentList, techExecutiveList } = this.props;
        // this.state.techSuperintendentArray[index] = techSuperintendentInfo;
        var index = this.state.techSuperintendentArray.findIndex(x => x.clientUserId === techSuperintendentInfo.clientUserId || x.email === techSuperintendentInfo.email);
        if (this.state.techSuperintendentInfo.email !== "") {
            if (emailregex.test(this.state.techSuperintendentInfo.email)) {
                const enteredEmail = this.state.techSuperintendentInfo.email.trim();
                const normalizedEmail = enteredEmail.toLowerCase();
                const emailExistsInClient =
                    (fleetManagerList || []).some(
                        (x) => x?.email?.trim().toLowerCase() === normalizedEmail
                    ) ||
                    (techSuperintendentList || []).some(
                        (x) =>
                            x?.clientUserId !== techSuperintendentInfo.clientUserId &&
                            x?.email?.trim().toLowerCase() === normalizedEmail
                    ) ||
                    (techExecutiveList || []).some(
                        (x) => x?.email?.trim().toLowerCase() === normalizedEmail
                    );

                if (emailExistsInClient) {
                    swal(
                        "Error!",
                        `User with email ${enteredEmail} already exists in this client.`,
                        "warning"
                    );
                    return;
                }

                this.state.techSuperintendentArray[index] = techSuperintendentInfo;
                this.setState({});
                this.props.dispatch({ type: "GetTechSuperintendentlist", data: this.state.techSuperintendentArray });
                this.hideSidePanel();
            }
            else {
                swal('Error!', 'Invalid email format', 'warning');
            }
        }
        else {
            swal('Error!', 'Email is mandatory', 'warning');
        }
    }

    hideSidePanel() {
        const { dispatch, match } = this.props;
        const { params } = match;
        const { id } = params;
        // this.props.history.goBack();
        this.props.dispatch({ type: "ShowSidePan", data: false });
        this.props.history.push(`/Home/Management/ClientEdit/${id}`);
    }

    render() {
        const { EditUser } = this.props;
        return (
            <div className="full-height">
                <div className="resource-list-auth-date row pt-3 ">
                    <div className='w-100'>
                        <div className="panel-box search-filter-box">
                            <button
                                className="btn btn-primary text-uppercase txtside-btn txtht-btn blue"
                                onClick={() => this.hideSidePanel()}
                            >
                                <div style={{ position: 'relative' }}>
                                    <span className="backarr">&larr;</span> <span style={{ marginLeft: "18px" }}>Return</span>
                                </div>
                            </button>
                            <div className="card mt-2 MM-card-header" style={{ backgroundColor: "white" }}>
                                <div className="card-body" style={{ padding: "0rem", backgroundColor: "#1a3464", color: "white" }}><h5 className="card-title ml-4 mt-2" style={{ color: "092a51" }}>Marine Superintendents</h5></div>
                            </div>
                            <div className="row search-filter-box">
                                <div className="col-lg-6">
                                    <label className="form-label">Name</label><br></br>
                                    <input type="text" className="form-control" name='userName' value={this.state.techSuperintendentInfo.userName} placeholder="Name" onChange={e => this.handleInputChange(e)}></input>
                                </div>
                                <div className="col-lg-6">
                                    <label className="form-label">Email<span className="mandatory">*</span></label><br></br>
                                    <input type="email" className="form-control" name='email' value={this.state.techSuperintendentInfo.email} placeholder="Email" onChange={e => this.handleInputChange(e)}
                                    //  disabled={EditUser}
                                    ></input>
                                </div>
                                <div className="col-lg-6">
                                    <label className="form-label">Phone</label><br></br>
                                    <input type="text" className="form-control" name='telephone' value={this.state.techSuperintendentInfo.telephone} placeholder="Phone" onChange={e => this.handleInputChange(e)}></input>
                                </div>
                                {/* <div className="col-lg-6">
                                    <label className="form-label">PIC Contact Details</label><br></br>
                                    <input type="text" className="form-control" name='picContactDetails' value={this.state.techSuperintendentInfo.picContactDetails} placeholder="PIC Contact Details" onChange={e => this.handleInputChange(e)}></input>
                                </div> */}
                                <div className="col-lg-12 mt-2 search-filter-box">
                                    <div className="search-btn-col" style={{ textAlign: 'end' }}>
                                        {!EditUser ?
                                            <button className="btn btn-primary text-uppercase txtside-btn txtht-btn blue" type="submit" onClick={() => this.addTechSuperintendent()}> Add </button>
                                            :
                                            <button className="btn btn-primary text-uppercase txtside-btn txtht-btn blue" type="submit" onClick={() => this.updateTechSuperintendent()}> Update </button>
                                        }
                                        <button className="btn btn-light text-uppercase txtside-btn txtht-btn ml-3" type="button" onClick={() => this.hideSidePanel()}> Cancel </button>
                                    </div>
                                </div>
                            </div>
                            {/* <div className="row">
                                <div className="col-lg-12 search-filter-box">
                                    <div className="search-btn-col" style={{ textAlign: 'end' }}>
                                        {!EditUser ?
                                            <button className="btn btn-primary text-uppercase txtside-btn txtht-btn blue" type="submit" onClick={() => this.addTechSuperintendent()}> Add </button>
                                            :
                                            <button className="btn btn-primary text-uppercase txtside-btn txtht-btn blue" type="submit" onClick={() => this.updateTechSuperintendent()}> Update </button>
                                        }
                                        <button className="btn btn-light text-uppercase txtside-btn txtht-btn ml-3" type="button" onClick={() => this.hideSidePanel()}> Cancel </button>
                                    </div>
                                </div>
                            </div> */}
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}
function mapDispatchToProps(dispatch) {
    return {
        dispatch,
    }
}
function mapStateToProps(state) {
    return {
        fleetManagerList: state.MasterScreenReducer.fleetManagerlist,
        techSuperintendentList: state.MasterScreenReducer.TechSuperintendentlist,
        techExecutiveList: state.MasterScreenReducer.TechExecutivelist,
        techSuperintendentDetail: state.MasterScreenReducer.TechSuperintendentDetail,
        EditUser: state.MasterScreenReducer.EditUser
    }
}
export default withRouter(connect(mapStateToProps, mapDispatchToProps)(EditSuperintendent));
